<template>
  <div class="enrolment-step2-page px-4 py-4 md:px-5">
    <div class="mx-auto space-y-5">
      <section class="intro-card">
      <!-- 수정일 땐 수강신청 수정 으로 변경  -->
      <p class="mb-2 text-[15px] font-semibold text-slate-900">
        {{ idxLeSugang ? "수강신청 수정" : "수강신청 등록" }}
      </p>
      <p class="text-sm text-slate-600">
        <span class="font-bold text-red-500">*</span> 그룹수강 신청 정원은 그룹 수강신청 에서 설정합니다.
      </p>
      </section>

      <section class="section-card">
      <p class="section-title">수강신청 정보 입력</p>
      <ul class="form-list">
        <li class="field-row field-row-divider">
          <p class="field-label"><span class="font-bold text-red-500">*</span> 과정명</p>
          <div class="field-content">
          <input
            v-model="registClass.registParams.sugangName"
            type="text"
            maxlength="50"
            class="form-control wide-control"
          />
          <p class="mt-1.5 text-xs font-bold text-red-500">
            줄바꿈이 필요하면 &lt;br&gt; 를 입력해주세요. 예) 2026년 진천 재수강용&lt;br&gt;테스트 페이지
          </p>
          <p class="mt-1 text-xs text-slate-500">
            최대 50자(&lt;br&gt; 포함) · 2줄 이내를 권장합니다. 현재 {{ (registClass.registParams.sugangName || "").length }}/50자
          </p>
          </div>
        </li>

        <li class="field-row field-row-divider">
          <p class="field-label">과정명 글자 크기</p>
          <div class="field-content">
          <div class="flex items-center gap-2">
            <input
              v-model.number="registClass.registParams.sugangNameFontSize"
              type="number"
              min="20"
              max="80"
              placeholder="62"
              class="form-control !min-w-0 w-28"
            />
            <p class="text-sm text-slate-600">px</p>
          </div>
          <p class="mt-1.5 text-xs text-slate-500">
            메인 화면 과정명의 PC 글자 크기입니다 (20~80). 비우면 기본 크기(62px)이며, 모바일은 비율에 맞춰 줄어듭니다.
          </p>
          </div>
        </li>

        <li class="field-row field-row-start field-row-divider">
          <p class="field-label">과정 설명</p>
          <div class="field-content">
          <textarea
            v-model="registClass.registParams.sugangDesc"
            rows="3"
            maxlength="300"
            placeholder="현지 원어민 강사님과 실시간 수업,&#10;4단계 완전학습으로 영어 실력을 한 단계 끌어올리세요!"
            class="form-control wide-control !h-auto"
          ></textarea>
          <p class="mt-1.5 text-xs text-slate-500">
            메인 화면 과정명 아래 문구입니다. 엔터나 &lt;br&gt; 로 줄을 바꿀 수 있습니다. 비우면 기본 문구가 나옵니다.
          </p>
          <p class="mt-1 text-xs text-slate-500">
            최대 300자 · 3줄 이내를 권장합니다. 현재 {{ (registClass.registParams.sugangDesc || "").length }}/300자
          </p>
          </div>
        </li>

        <li class="field-row field-row-divider">
          <p class="field-label">과정 설명 글자 크기</p>
          <div class="field-content">
          <div class="flex items-center gap-2">
            <input
              v-model.number="registClass.registParams.sugangDescFontSize"
              type="number"
              min="12"
              max="40"
              placeholder="20"
              class="form-control !min-w-0 w-28"
            />
            <p class="text-sm text-slate-600">px</p>
          </div>
          <p class="mt-1.5 text-xs text-slate-500">
            메인 화면 과정 설명의 PC 글자 크기입니다 (12~40). 비우면 기본 크기(20px)이며, 모바일은 비율에 맞춰 줄어듭니다.
          </p>
          </div>
        </li>

        <li class="field-row field-row-start field-row-divider">
          <p class="field-label">메인 화면 미리보기</p>
          <div class="field-content min-w-0">
          <!-- 사용자 메인 배너(PC)와 같은 글자 크기·줄바꿈 폭(720px)으로 보여준다 -->
          <div class="overflow-x-auto rounded-xl border border-slate-200 bg-slate-50 p-6">
            <div class="w-[720px] break-keep text-[#101010]">
              <p class="mb-[34px] font-bold" :style="registClass.previewTitleStyle()">
                <template v-for="(line, index) in registClass.previewTitleLines()" :key="index">
                  <br v-if="index > 0" />{{ line }}
                </template>
              </p>
              <p class="whitespace-pre-line font-medium" :style="registClass.previewDescStyle()">{{
                registClass.previewDescText() ||
                "현지 원어민 강사님과 실시간 수업,\n4단계 완전학습으로 영어 실력을 한 단계 끌어올리세요!"
              }}</p>
            </div>
          </div>
          <p class="mt-1.5 text-xs text-slate-500">
            PC 화면 기준입니다. 실제 화면에서는 오른쪽에 배경 사진이 있고, 모바일은 글자가 약 70% 크기로 줄어듭니다.
          </p>
          </div>
        </li>

        <li class="field-row field-row-start field-row-divider">
          <p class="field-label"><span class="font-bold text-red-500">*</span> 수강신청 기간</p>
          <div class="field-content">
          <ul class="date-period-list">
            <li class="date-period-item">
              <BagicDatePickerStartDate
                :startDate="registClass.registParams.startDate"
                @date-click="registClass.setStartDate"
                class="date-picker-frame"
              ></BagicDatePickerStartDate>
              <ul class="date-time-list">
                <li class="date-time-item">
                  <select
                    class="form-control select-control select-control-sm"
                    v-model="registClass.registParams.startDateTime"
                  >
                    <option v-for="hour in registClass.startHours" :key="hour" :value="hour">
                      {{ hour }}
                    </option>
                  </select>
                  <p class="time-unit">시</p>
                </li>
                <li class="date-time-item">
                  <select
                    class="form-control select-control select-control-sm"
                    v-model="registClass.registParams.startDateMinute"
                  >
                    <option v-for="minute in registClass.startMinutes" :key="minute" :value="minute">
                      {{ minute }}
                    </option>
                  </select>
                  <p class="time-unit">분</p>
                </li>
              </ul>
            </li>
            <li class="date-separator">~</li>
            <li class="date-period-item">
              <BagicDatePickerEndDate
                :endDate="registClass.registParams.endDate"
                @date-click="registClass.setEndDate"
                class="date-picker-frame"
              ></BagicDatePickerEndDate>
              <ul class="date-time-list">
                <li class="date-time-item">
                  <select
                    class="form-control select-control select-control-sm"
                    v-model="registClass.registParams.endDateTime"
                  >
                    <option v-for="hour in registClass.endHours" :key="hour" :value="hour">
                      {{ hour }}
                    </option>
                  </select>
                  <p class="time-unit">시</p>
                </li>
                <li class="date-time-item">
                  <select
                    class="form-control select-control select-control-sm"
                    v-model="registClass.registParams.endDateMinute"
                  >
                    <option v-for="minute in registClass.endMinutes" :key="minute" :value="minute">
                      {{ minute }}
                    </option>
                  </select>

                  <p class="time-unit">분</p>
                </li>
              </ul>
            </li>
          </ul>
          </div>
        </li>

        <li class="field-row field-row-start field-row-divider">
          <p class="field-label"><span class="font-bold text-red-500">*</span> 교육기간</p>
          <div class="field-content">
          <ul class="date-period-list">
            <li class="date-range-item">
              <BagicDatePickerRange
                :eduStartDate="registClass.registParams.eduStartDate"
                :eduEndDate="registClass.registParams.eduEndDate"
                @date-click="registClass.setDate"
                class="date-picker-frame"
              >
              </BagicDatePickerRange>
            </li>
          </ul>
          </div>
        </li>

        <li class="field-row field-row-divider">
          <p class="field-label"><span class="font-bold text-red-500">*</span> 과세여부</p>
          <div class="field-content">
          <ul class="option-group">
            <li class="option-item">
              <label class="option-label">
              <input v-model="registClass.registParams.isTax" value="N" type="radio" name="taxTarget" id="isTaxFree" />
              <span>면세</span>
              </label>
            </li>
            <li class="option-item">
              <label class="option-label">
              <input v-model="registClass.registParams.isTax" value="Y" type="radio" name="taxTarget" id="isTax" />
              <span>과세</span>
              </label>
            </li>
          </ul>
          </div>
        </li>

        <li class="dual-field-row field-row-divider">
          <div class="dual-field">
            <p class="field-label"><span class="font-bold text-red-500">*</span> 1:1 지원대상자</p>
            <div class="field-content">
            <ul class="option-group">
              <li class="option-item">
                <label class="option-label" for="supportTarget1">
                <input
                  v-model="registClass.registParams.isOneSup"
                  value="Y"
                  type="radio"
                  name="supportTarget"
                  id="supportTarget1"
                />
                <span>사용</span>
                </label>
              </li>
              <li class="option-item">
                <label class="option-label" for="supportTarget2">
                <input
                  v-model="registClass.registParams.isOneSup"
                  value="N"
                  type="radio"
                  name="supportTarget"
                  id="supportTarget2"
                />
                <span>사용 안함</span>
                </label>
              </li>
            </ul>
            </div>
          </div>

          <div class="dual-field">
            <p class="field-label"><span class="font-bold text-red-500">*</span> 그룹 지원대상자</p>
            <div class="field-content">
            <ul class="option-group">
              <li class="option-item">
                <label class="option-label" for="groupSupportTarget1">
                <input
                  v-model="registClass.registParams.isGroupSup"
                  value="Y"
                  type="radio"
                  name="groupSupportTarget"
                  id="groupSupportTarget1"
                />
                <span>사용</span>
                </label>
              </li>
              <li class="option-item">
                <label class="option-label" for="groupSupportTarget2">
                <input
                  v-model="registClass.registParams.isGroupSup"
                  value="N"
                  type="radio"
                  name="groupSupportTarget"
                  id="groupSupportTarget2"
                />
                <span>사용 안함</span>
                </label>
              </li>
            </ul>
            </div>
          </div>
        </li>

        <li class="field-row field-row-start field-row-divider">
          <p class="field-label"><span class="font-bold text-red-500">*</span> 1:1 수강신청 정원(일반)</p>
          <div class="field-content">
          <ul class="limit-stack">
            <li class="limit-choice-row">
              <label class="option-label option-label-plain" for="personnel1">
              <input
                type="radio"
                name="personnel"
                id="personnel1"
                v-model="registClass.registParams.studentLimitOne"
                :value="0"
                @change="registClass.handleLimitChange"
              />
              <span>제한 없음</span>
              </label>
            </li>
            <li class="limit-setting-row">
              <div class="limit-toggle">
                <input type="radio" name="personnel" id="personnel2" :checked="registClass.registParams.studentLimitOne !== 0" />
                <label class="cursor-pointer" for="personnel2">과정 전체</label>
              </div>
              <div class="limit-input-group">
                <p class="limit-input-label">선착순</p>
                <div class="limit-input-box">
                  <input
                    type="text"
                    class="form-control count-control"
                    v-model="registClass.registParams.studentLimitOne"
                  />
                  <p class="time-unit">명</p>
                </div>
              </div>
              <div class="limit-input-group">
                <p class="limit-input-label">대기자</p>
                <div class="limit-input-box">
                  <input
                    type="text"
                    class="form-control count-control"
                    v-model="registClass.registParams.studentLimitWaitOne"
                  />
                  <p class="time-unit">명</p>
                </div>
              </div>
            </li>
            <li class="helper-text">
              <span class="font-bold text-red-500">*</span>
              <span>대기자가 없으면 <span class="text-red-500">0명</span> 으로 입력 해주세요</span>
            </li>
          </ul>
          </div>
        </li>

        <li v-if="registClass.registParams.isOneSup === 'Y'" class="field-row field-row-start field-row-divider">
          <p class="field-label"><span class="font-bold text-red-500">*</span> 1:1 수강신청 정원(지원)</p>
          <div class="field-content">
          <ul class="limit-stack">
            <li class="limit-choice-row">
              <label class="option-label option-label-plain" for="personnel3">
              <input
                type="radio"
                name="personnel0"
                id="personnel3"
                v-model="registClass.registParams.studentLimitOneSup"
                :value="0"
                @change="registClass.handleLimitWaitChange"
              />
              <span>제한 없음</span>
              </label>
            </li>
            <li class="limit-setting-row">
              <div class="limit-toggle">
                <input
                  type="radio"
                  name="personnel0"
                  id="personnel4"
                  :checked="registClass.registParams.studentLimitOneSup !== 0"
                />
                <label class="cursor-pointer" for="personnel4">과정 전체</label>
              </div>
              <div class="limit-input-group">
                <p class="limit-input-label">선착순</p>
                <div class="limit-input-box">
                  <input
                    type="text"
                    class="form-control count-control"
                    v-model="registClass.registParams.studentLimitOneSup"
                  />
                  <p class="time-unit">명</p>
                </div>
              </div>
              <div class="limit-input-group">
                <p class="limit-input-label">대기자</p>
                <div class="limit-input-box">
                  <input
                    type="text"
                    class="form-control count-control"
                    v-model="registClass.registParams.studentLimitWaitOneSup"
                  />
                  <p class="time-unit">명</p>
                </div>
              </div>
            </li>
            <li class="helper-text">
              <span class="font-bold text-red-500">*</span>
              <span>대기자가 없으면 <span class="text-red-500">0명</span> 으로 입력 해주세요</span>
            </li>
          </ul>
          </div>
        </li>

        <li class="field-row field-row-divider">
          <p class="field-label"><span class="font-bold text-red-500">*</span> 일반 버튼명</p>
          <div class="field-content">
          <input
            v-model="registClass.registParams.normalButtonName"
            type="text"
            maxlength="50"
            class="form-control wide-control"
          />
          </div>
        </li>

        <li
          v-if="registClass.registParams.isOneSup === 'Y' || registClass.registParams.isGroupSup === 'Y'"
          class="field-row field-row-divider"
        >
          <p class="field-label">지원 버튼명</p>
          <div class="field-content">
          <input
            v-model="registClass.registParams.supButtonName"
            type="text"
            maxlength="50"
            class="form-control wide-control"
          />
          </div>
        </li>

        <li class="field-row field-row-divider">
          <p class="field-label"><span class="font-bold text-red-500">*</span> 중복신청 기준</p>
          <div class="field-content">
          <ul class="option-group">
            <li class="option-item">
              <label class="option-label" for="duplication1">
              <input type="radio" name="duplication" id="duplication1" v-model="registClass.registParams.duplicate" value="Y" />
              <span>중복신청 가능</span>
              </label>
            </li>
            <li class="option-item">
              <label class="option-label" for="duplication2">
              <input type="radio" name="duplication" id="duplication2" v-model="registClass.registParams.duplicate" value="N" />
              <span>중복신청 불가</span>
              </label>
            </li>
          </ul>
          </div>
        </li>

        <li class="field-row field-row-divider">
          <p class="field-label"><span class="font-bold text-red-500">*</span> 자기주도학습</p>
          <div class="field-content">
          <ul class="option-group">
            <li class="option-item">
              <label class="option-label" for="isQuestion1">
              <input type="radio" name="isQuestion" id="isQuestion1" v-model="registClass.registParams.isQuestion" value="Y" />
              <span>활성</span>
              </label>
            </li>
            <li class="option-item">
              <label class="option-label" for="isQuestion2">
              <input type="radio" name="isQuestion" id="isQuestion2" v-model="registClass.registParams.isQuestion" value="N" />
              <span>비활성</span>
              </label>
            </li>
          </ul>
          </div>
        </li>

        <li class="field-row field-row-divider">
          <p class="field-label"><span class="font-bold text-red-500">*</span> 취소기능 생성여부</p>
          <div class="field-content">
          <ul class="option-group">
            <li class="option-item">
              <label class="option-label" for="cancel1">
              <input v-model="registClass.registParams.isCancelFunction" value="Y" type="radio" name="cancel" id="cancel1" />
              <span>사용</span>
              </label>
            </li>
            <li class="option-item">
              <label class="option-label" for="cancel2">
              <input v-model="registClass.registParams.isCancelFunction" value="N" type="radio" name="cancel" id="cancel2" />
              <span>사용 안함</span>
              </label>
            </li>
          </ul>
          </div>
        </li>

        <li class="field-row field-row-divider">
          <p class="field-label"><span class="font-bold text-red-500">*</span> 서류제출안내</p>
          <div class="field-content">
          <ul class="option-group">
            <li class="option-item">
              <label class="option-label" for="supDocument1">
              <input v-model="supDocUse" value="Y" type="radio" name="supDocument" id="supDocument1" />
              <span>사용</span>
              </label>
            </li>
            <li class="option-item">
              <label class="option-label" for="supDocument2">
              <input v-model="supDocUse" value="N" type="radio" name="supDocument" id="supDocument2" />
              <span>사용 안함</span>
              </label>
            </li>
          </ul>
          <ul v-if="supDocUse === 'Y'" class="option-group mt-2">
            <li class="option-item">
              <label class="option-label" for="supDocumentNormal">
              <input v-model="supDocNormal" type="checkbox" id="supDocumentNormal" />
              <span>일반</span>
              </label>
            </li>
            <li class="option-item">
              <label class="option-label" for="supDocumentSup">
              <input v-model="supDocSup" type="checkbox" id="supDocumentSup" />
              <span>지원</span>
              </label>
            </li>
          </ul>
          <p class="mt-1.5 text-xs text-slate-500">
            사용이면 체크한 대상(일반·지원, 중복 선택 가능)만 서류를 첨부·제출합니다. 사용 안함이면 일반/지원대상 모두 수강신청 화면의 서류 첨부와 수강신청 내역확인의 서류 제출이 숨겨집니다.
          </p>
          </div>
        </li>

        <li class="field-row">
          <p class="field-label"><span class="font-bold text-red-500">*</span> HQ 매니저</p>
          <div class="field-content">
          <select v-model="registClass.registParams.idxStaff" class="form-control select-control">
            <option value="0">전체</option>
            <option v-for="(item, i) in registClass.staffList" :key="i" :value="item.idx">
              {{ item.ename }} ({{ item.kname }})
            </option>
          </select>
          </div>
        </li>
      </ul>
      </section>

      <section class="section-card">
      <p class="section-title">수강신청 유형 선택</p>
      <div class="field-row field-row-start">
        <p class="field-label"><span class="font-bold text-red-500">*</span> 수강신청 유형</p>
        <div class="field-content">
        <ul class="type-grid">
          <li class="type-card">
            <div class="type-choice">
              <label class="option-label option-label-wide" for="type1">
              <input
                type="checkbox"
                name="type"
                id="type1"
                true-value="Y"
                false-value="N"
                v-model="registClass.registParams.isOne"
              />
              <span>1:1 수업</span>
              </label>
            </div>
            <div class="type-code-row">
              <label class="type-code-label" for="code"><span class="font-bold text-red-500">*</span> 1:1 과정코드입력</label>
              <input
                type="text"
                id="code"
                class="form-control code-input"
                v-model="registClass.registParams.isOneCode"
                @change="registClass.restrictToNumbers(false)"
              />
              <button type="button" class="primary-inline-button" @click="registClass.checkCtmCode">
                코드 확인
              </button>
            </div>
            <div class="type-code-row">
              <label class="type-code-label" for="retakeSugang">재수강 대상 과정집</label>
              <select id="retakeSugang" v-model="registClass.registParams.retakeIdxLeSugang" class="form-control retake-select-control">
                <option :value="0">사용 안 함</option>
                <option v-for="item in registClass.retakeSugangList" :key="item.idxLeSugang" :value="item.idxLeSugang">
                  {{ item.sugangName }} ({{ item.eduStartDate }} ~ {{ item.eduEndDate }})
                </option>
              </select>
            </div>
            <p class="helper-text">선택한 과정집에서 1:1 수업을 들은 학습자에게만 [재수강 신청하기]가 보입니다.</p>
          </li>

          <li class="type-card">
            <div class="type-choice">
              <label class="option-label option-label-wide" for="type2">
                <input
                  type="checkbox"
                  name="type"
                  id="type2"
                  v-model="registClass.registParams.isGroup"
                  true-value="Y"
                  false-value="N"
                />
                <span>그룹 수업</span>
              </label>
            </div>
          </li>
        </ul>
        </div>
      </div>
      </section>

      <section class="action-card">
      <div class="action-row">
      <button type="button" class="secondary-action-button" @click="registClass.goBack">이전 페이지</button>
      <button
        type="button"
        v-if="!registClass.classUpdate"
        class="primary-action-button"
        @click="registClass.registSugang(true)"
      >
        다음 페이지 (저장)
      </button>
      <button
        type="button"
        v-else
        class="primary-action-button"
        @click="registClass.registSugang(false)"
      >
        다음 페이지 (수정)
      </button>
      </div>
      </section>
    </div>
  </div>
</template>
<script>
import { computed, onMounted, reactive } from "vue";
import { useRouter, useRoute } from "vue-router";
import axios from "@/plugins/axios.js";
import BagicDatePickerRange from "@/components/BagicDatePickerRange.vue";
import BagicDatePickerStartDate from "@/components/BagicDatePickerStartDate.vue";
import BagicDatePickerEndDate from "@/components/BagicDatePickerEndDate.vue";

export default {
  components: {
    BagicDatePickerRange,
    BagicDatePickerStartDate,
    BagicDatePickerEndDate,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const idxLeSiteMain = route.query.idxLeSiteMain;
    const idxLeSugang = route.query.idxLeSugang;

    const registClass = reactive({
      registParams: {
        // staffIdx: 0,
        idxLeSiteMain: "",
        eduEndDate: "",
        idxStaff: 0,
        idxSugang: "",
        idxLeSugang: "",
        idxCtmB2b: "",
        isOneCode: "",
        eduStartDate: "",
        studentLimitOne: 0,
        studentLimitWaitOne: 0,
        studentLimitOneSup: 0,
        studentLimitWaitOneSup: 0,
        sugangName: "",
        normalButtonName: "",
        supButtonName: "",
        isCancelFunction: "",
        duplicate: "",
        isQuestion: "",
        endDate: "",
        startDate: "",
        startDateTime: "0",
        endDateTime: "0",
        startDateMinute: "0",
        endDateMinute: "0",
        isOne: "N",
        isTax: "N",
        isGroup: "N",
        isOneSup: "",
        isGroupSup: "",
        sugangDesc: "",
        sugangNameFontSize: null,
        sugangDescFontSize: null,
        isSupDocument: "Y",
        retakeIdxLeSugang: 0,
      },

      retakeSugangList: [],

      classUpdate: false,

      staffList: [],

      codeCheck: false,

      codeCheckDone: false,

      startHours: Array.from({ length: 24 }, (_, index) => index.toString().padStart(2, "0")),
      startMinutes: Array.from({ length: 6 }, (_, index) => (index * 10).toString().padStart(2, "0")),

      endHours: Array.from({ length: 24 }, (_, index) => index.toString().padStart(2, "0")),
      endMinutes: Array.from({ length: 6 }, (_, index) => (index * 10).toString().padStart(2, "0")),

      // 메인 화면 미리보기: 과정명 <br> 줄바꿈, 글자 크기(비우면 기본 62px)
      previewTitleLines() {
        return (registClass.registParams.sugangName || "과정명").split(/<br\s*\/?>/i);
      },

      // 과정 설명은 엔터와 <br> 둘 다 줄바꿈으로 본다 (사용자 메인과 같은 규칙)
      previewDescText() {
        return (registClass.registParams.sugangDesc || "").replace(/<br\s*\/?>/gi, "\n").trim();
      },

      previewDescStyle() {
        const size = Number(registClass.registParams.sugangDescFontSize) || 20;
        return { fontSize: `${size}px`, lineHeight: 1.5 };
      },

      previewTitleStyle() {
        const size = Number(registClass.registParams.sugangNameFontSize) || 62;
        return { fontSize: `${size}px`, lineHeight: 1.2 };
      },

      handleLimitChange() {
        if (registClass.registParams.studentLimitOne === 0) {
          registClass.registParams.studentLimitOne = 0;
          registClass.registParams.studentLimitWaitOne = 0;
        }
      },

      handleLimitWaitChange() {
        if (registClass.registParams.studentLimitOneSup === 0) {
          registClass.registParams.studentLimitOneSup = 0;
          registClass.registParams.studentLimitWaitOneSup = 0;
        }
      },

      // 수강 조회
      getSugang() {
        const idxLeSugang = route.query.idxLeSugang;

        if (idxLeSugang && idxLeSugang !== "0") {
          const params = {
            idxLeSugang: idxLeSugang,
          };
          axios.get("/admin/sugang", { params }).then(function (res) {
            if (res.data.success) {
              registClass.registParams = res.data.data.sugangInfo;
              // 서류제출 대상: Y=지원, G=일반, A=일반·지원, N=사용 안 함. 값이 없으면(이전 데이터) 지원
              if (!["Y", "G", "A", "N"].includes(registClass.registParams.isSupDocument)) registClass.registParams.isSupDocument = "Y";

              const startDateParts = res.data.data.sugangInfo.startDate.split(" ");
              const startTimeParts = startDateParts[1].split(":");
              registClass.registParams.startDateTime = startTimeParts[0];
              registClass.registParams.startDateMinute = startTimeParts[1];

              const endDateParts = res.data.data.sugangInfo.endDate.split(" ");
              const endTimeParts = endDateParts[1].split(":");
              registClass.registParams.endDateTime = endTimeParts[0];
              registClass.registParams.endDateMinute = endTimeParts[1];

              registClass.staffList.idx = res.data.data;
              registClass.classUpdate = true;
            } else {
              // 처리 실패 로직
            }
          });
        }
      },

      // 재수강 대상 과정집 목록 (현재 과정집 제외)
      getRetakeSugangList() {
        const params = idxLeSugang && idxLeSugang !== "0" ? { idxLeSugang } : {};
        axios.get("/admin/sugang/retakeList", { params }).then(function (res) {
          if (res.data.success) {
            registClass.retakeSugangList = res.data.data.retakeSugangList;
          } else {
            alert(res.data.message);
          }
        });
      },

      // 스태프 조회
      getStaffList() {
        axios.get("/admin/staffList", {}).then(function (res) {
          if (res.data.success) {
            registClass.staffList = res.data.data.companyList;
          } else {
            alert(res.data.message);
          }
        });
      },

      restrictToNumbers(value) {
        localStorage.setItem("codeCheckDone", value.toString());
        registClass.registParams.isOneCode = registClass.registParams.isOneCode.replace(/[^0-9]/g, "");
      },

      // 1:1 과정 코드 확인
      checkCtmCode() {
        const isOneCode = registClass.registParams.isOneCode;
        if (!isOneCode) {
          alert("1:1 과정코드를 입력하세요.");
          return;
        }
        axios.get(`/admin/ctmCode?idxCtmB2b=${isOneCode}`, {}).then(function (res) {
          if (res.data.success) {
            alert("코드가 존재 합니다.");
            registClass.codeCheck = true;
            localStorage.setItem("codeCheckDone", "true");
          } else {
            alert("코드가 존재하지 않습니다.");
            registClass.codeCheck = false;
          }
          // listPage.is_loader = false;
        });
      },

      // 수강 등록
      registSugang() {
        registClass.registParams.idxLeSiteMain = route.query.idxLeSiteMain;

        const codeCheckDone = localStorage.getItem("codeCheckDone");

        if (!registClass.registParams.sugangName) {
          alert("과정명을 입력하세요.");
          return;
        }

        // 빈 입력은 기본 크기(null)로 저장한다.
        const fontSize = registClass.registParams.sugangNameFontSize;
        if (fontSize === "" || fontSize === undefined) registClass.registParams.sugangNameFontSize = null;
        if (
          registClass.registParams.sugangNameFontSize !== null &&
          !(
            Number.isInteger(registClass.registParams.sugangNameFontSize) &&
            registClass.registParams.sugangNameFontSize >= 20 &&
            registClass.registParams.sugangNameFontSize <= 80
          )
        ) {
          alert("과정명 글자 크기는 20~80px 사이의 정수로 입력하세요.");
          return;
        }

        const descFontSize = registClass.registParams.sugangDescFontSize;
        if (descFontSize === "" || descFontSize === undefined) registClass.registParams.sugangDescFontSize = null;
        if (
          registClass.registParams.sugangDescFontSize !== null &&
          !(
            Number.isInteger(registClass.registParams.sugangDescFontSize) &&
            registClass.registParams.sugangDescFontSize >= 12 &&
            registClass.registParams.sugangDescFontSize <= 40
          )
        ) {
          alert("과정 설명 글자 크기는 12~40px 사이의 정수로 입력하세요.");
          return;
        }

        if (!registClass.registParams.startDate || !registClass.registParams.endDate) {
          alert("수강신청 기간을 입력하세요.");
          return;
        }

        if (registClass.registParams.endDate < registClass.registParams.startDate) {
          alert("시작일을 종료일보다 과거로 설정해주세요");
          return;
        }

        if (
          !registClass.registParams.startDateTime ||
          registClass.registParams.startDateTime === "0" ||
          !registClass.registParams.startDateMinute ||
          registClass.registParams.startDateMinute === "0"
        ) {
          alert("시작시간을 입력하세요.");
          return;
        }

        if (
          !registClass.registParams.endDateTime ||
          registClass.registParams.endDateTime === "0" ||
          !registClass.registParams.endDateMinute ||
          registClass.registParams.endDateMinute === "0"
        ) {
          alert("종료시간을 입력하세요.");
          return;
        }

        if (!registClass.registParams.eduStartDate || !registClass.registParams.eduEndDate) {
          alert("교육기간을 입력하세요.");
          return;
        }

        if (!registClass.registParams.normalButtonName) {
          alert("일반 버튼명을 입력해주세요.");
          return;
        }

        if (!registClass.registParams.duplicate) {
          alert("중복 신청 기준을 선택하세요.");
          return;
        }

        if (!registClass.registParams.isQuestion) {
          alert("자기주도학습을 선택하세요.");
          return;
        }

        if (!registClass.registParams.isCancelFunction) {
          alert("취소기능 생성여부를 선택하세요.");
          return;
        }

        if (!registClass.registParams.idxStaff) {
          alert("HQ 매니저를 선택하세요.");
          return;
        }

        if (!["Y", "G", "A", "N"].includes(registClass.registParams.isSupDocument)) {
          alert("서류제출 대상(일반·지원)을 하나 이상 선택하세요.");
          return;
        }

        if (registClass.registParams.isOne === "N" && registClass.registParams.isGroup === "N") {
          alert("수강신청 유형을 선택하세요.");
          return;
        }

        if (codeCheckDone === "true") {
        } else if (registClass.registParams.isOne === "Y" && !registClass.codeCheck) {
          alert("1:1 수업 과정코드를 확인하세요.");
          return;
        }

        registClass.registParams.startDate = `${registClass.registParams.startDate.split(" ")[0]} ${
          registClass.registParams.startDateTime
        }:${registClass.registParams.startDateMinute}`;
        registClass.registParams.endDate = `${registClass.registParams.endDate.split(" ")[0]} ${
          registClass.registParams.endDateTime
        }:${registClass.registParams.endDateMinute}`;

        const params = registClass.registParams;

        axios.post("/admin/sugang", params, {}).then(function (res) {
          if (res.data.success) {
            const idxLeSugang = res.data.data.idxLeSugang;
            if (registClass.classUpdate) {
              localStorage.setItem("codeCheckDone", "false");
              alert("수정되었습니다.");
              if (registClass.registParams.isOne === "Y" && registClass.registParams.isGroup === "Y") {
                router.push({
                  path: "/enrolmentStep3_1",
                  query: { idxLeSugang: idxLeSugang },
                });
              } else if (registClass.registParams.isOne === "Y") {
                router.push({
                  path: "/enrolmentStep3_1",
                  query: { idxLeSugang: idxLeSugang },
                });
              } else if (registClass.registParams.isGroup === "Y") {
                router.push({
                  path: "/enrolmentStep3_2",
                  query: { idxLeSugang: idxLeSugang },
                });
              }
            } else if (idxLeSugang) {
              localStorage.setItem("codeCheckDone", "false");
              alert("수강신청 등록 완료");
              if (registClass.registParams.isOne === "Y" && registClass.registParams.isGroup === "Y") {
                router.push({
                  path: "/enrolmentStep3_1",
                  query: { idxLeSugang: idxLeSugang },
                });
              } else if (registClass.registParams.isOne === "Y") {
                router.push({
                  path: "/enrolmentStep3_1",
                  query: { idxLeSugang: idxLeSugang },
                });
              } else if (registClass.registParams.isGroup === "Y") {
                router.push({
                  path: "/enrolmentStep3_2",
                  query: { idxLeSugang: idxLeSugang },
                });
              }
            }
          } else {
            alert(res.data.message);
          }
          // listPage.is_loader = false;
        });
      },

      setStartDate(dateArr) {
        registClass.registParams.startDate = dateArr[0];
      },
      setEndDate(dateArr) {
        registClass.registParams.endDate = dateArr[0];
      },

      setDate(dateArr) {
        registClass.registParams.eduStartDate = dateArr[0];
        registClass.registParams.eduEndDate = dateArr[1];
      },

      goBack() {
        if (!confirm("작업 내용이 저장되지 않습니다. 이전 페이지로 이동하시겠습니까?")) {
          return;
        }

        if (idxLeSiteMain) {
          router.push({
            path: `/enrolmentStep1`,
            query: {
              idxLeSiteMain: idxLeSiteMain,
            },
          });
        } else if (!idxLeSugang) {
          window.history.back();
        } else {
          router.push({
            path: `/enrolmentStep1`,
            query: {
              idxLeSiteMain: registClass.registParams.idxLeSiteMain,
            },
          });
        }
      },
    });

    onMounted(() => {
      // 1:1, 그룹 과정코드 로컬스토라지에서 제어 하는 부분
      const params = new URLSearchParams(window.location.search);
      const idxLeSugang = params.get("idxLeSugang");
      const idxLeSiteMain = params.get("idxLeSiteMain");
      // codeCheckDone 값을 설정합니다.
      if (idxLeSugang) {
        localStorage.setItem("codeCheckDone", "true");
      } else if (idxLeSiteMain) {
        localStorage.setItem("codeCheckDone", "false");
      }
      registClass.getStaffList();
      registClass.getRetakeSugangList();
      registClass.getSugang();
    });

    // 서류제출안내: 사용/사용 안함 + 대상(일반·지원) → isSupDocument (Y=지원, G=일반, A=일반·지원, N=사용 안 함)
    // 대상을 둘 다 끄면 빈 값이 되고, 저장할 때 막는다
    const setSupDocTarget = (normal, sup) => {
      registClass.registParams.isSupDocument = normal && sup ? "A" : normal ? "G" : sup ? "Y" : "";
    };
    const supDocUse = computed({
      get: () => (registClass.registParams.isSupDocument === "N" ? "N" : "Y"),
      set: (v) => {
        registClass.registParams.isSupDocument = v === "N" ? "N" : "Y";
      },
    });
    const supDocNormal = computed({
      get: () => ["G", "A"].includes(registClass.registParams.isSupDocument),
      set: (v) => setSupDocTarget(v, supDocSup.value),
    });
    const supDocSup = computed({
      get: () => ["Y", "A"].includes(registClass.registParams.isSupDocument),
      set: (v) => setSupDocTarget(supDocNormal.value, v),
    });

    return {
      registClass,
      idxLeSiteMain,
      idxLeSugang,
      supDocUse,
      supDocNormal,
      supDocSup,
    };
  },
};
</script>
<style scoped>
.enrolment-step2-page {
  min-height: 100%;
  background:
    radial-gradient(circle at top left, rgba(226, 232, 240, 0.65), transparent 32rem),
    linear-gradient(180deg, #f8fafc 0%, #ffffff 42%);
}

.intro-card,
.section-card,
.action-card {
  margin: 0 auto;
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  background: #fff;
  padding: 1.25rem;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.section-title {
  margin-bottom: 1rem;
  padding-bottom: 0.85rem;
  border-bottom: 1px solid #e2e8f0;
  font-size: 1rem;
  font-weight: 600;
  color: #0f172a;
}

.form-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.field-row {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.field-row-start {
  align-items: flex-start;
}

.field-row-divider {
  padding-bottom: 1rem;
  border-bottom: 1px solid #e2e8f0;
}

.field-label {
  flex: none;
  width: 9rem;
  padding-top: 0.75rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #64748b;
}

.field-content {
  flex: 1;
  min-width: 0;
}

.dual-field-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.dual-field {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.form-control,
.enrolment-step2-page select,
.enrolment-step2-page input[type="text"] {
  height: 2.875rem;
  min-width: 14rem;
  border: 1px solid #cbd5e1 !important;
  border-radius: 0.75rem;
  background-color: #fff;
  padding: 0.7rem 0.9rem;
  font-size: 0.95rem;
  color: #0f172a;
  outline: none;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.form-control:focus,
.enrolment-step2-page select:focus,
.enrolment-step2-page input[type="text"]:focus {
  border-color: #94a3b8 !important;
  box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.15);
}

.wide-control {
  width: 100%;
  max-width: 42rem;
  min-width: 0;
}

.select-control {
  width: 100%;
  max-width: 18rem;
  cursor: pointer;
}

.select-control-sm {
  min-width: 5.5rem;
  width: 5.5rem;
}

.retake-select-control {
  width: 100%;
  max-width: 32rem;
  cursor: pointer;
}

.date-period-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.9rem;
}

.date-period-item,
.date-range-item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.9rem;
}

.date-separator,
.time-unit {
  font-size: 0.875rem;
  color: #64748b;
}

.date-time-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.date-time-item {
  display: flex;
  align-items: center;
  gap: 0.45rem;
}

.date-picker-frame {
  display: inline-flex;
  align-items: center;
  min-height: 2.875rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.75rem;
  background: #fff;
  padding: 0 0.2rem;
}

.option-group {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.option-item {
  list-style: none;
}

.option-label {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  min-height: 2.875rem;
  border: 1px solid #e2e8f0;
  border-radius: 9999px;
  background: #f8fafc;
  padding: 0.7rem 1rem;
  font-size: 0.9rem;
  color: #334155;
  cursor: pointer;
}

.option-label-plain {
  border-radius: 0.75rem;
}

.option-label-wide {
  min-width: 8rem;
  justify-content: center;
}

.limit-stack {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.limit-choice-row {
  display: flex;
  align-items: center;
}

.limit-setting-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.9rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  background: #f8fafc;
}

.limit-toggle {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  min-height: 2.875rem;
  font-size: 0.9rem;
  color: #334155;
}

.limit-input-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.limit-input-label {
  font-size: 0.875rem;
  color: #475569;
}

.limit-input-box {
  display: flex;
  align-items: center;
  gap: 0.45rem;
}

.count-control {
  min-width: 0;
  width: 4.5rem;
  text-align: center;
}

.type-grid {
  display: grid;
  gap: 1rem;
}

.type-card {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  background: #f8fafc;
}

.type-choice {
  display: flex;
  align-items: center;
}

.type-code-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}

.type-code-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #475569;
}

.code-input {
  width: 100%;
  max-width: 16rem;
}

.primary-inline-button {
  border: 1px solid #2563eb;
  border-radius: 0.75rem;
  background: #2563eb;
  padding: 0.7rem 1rem;
  font-size: 0.9rem;
  font-weight: 700;
  color: #fff;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;
}

.primary-inline-button:hover,
.primary-action-button:hover {
  background: #1d4ed8;
  border-color: #1d4ed8;
}

.helper-text {
  font-size: 0.8125rem;
  color: #64748b;
}

.action-row {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}

.secondary-action-button,
.primary-action-button {
  display: inline-flex;
  min-height: 2.875rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
  padding: 0.7rem 1rem;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;
}

.secondary-action-button {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #475569;
}

.secondary-action-button:hover {
  background: #f8fafc;
}

.primary-action-button {
  border: 1px solid #2563eb;
  background: #2563eb;
  color: #fff;
}

.enrolment-step2-page input[type="radio"],
.enrolment-step2-page input[type="checkbox"] {
  accent-color: #2563eb;
}

@media (max-width: 1023px) {
  .field-row,
  .dual-field,
  .action-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .dual-field-row,
  .type-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .field-label {
    width: 100%;
    padding-top: 0;
  }

  .secondary-action-button,
  .primary-action-button {
    width: 100%;
  }
}

@media (min-width: 1024px) {
  .type-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
